import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { InitAppService, LogoPickerComponent } from '@mca-feature';
import { BaseLogoComponent } from '@shared/ui';

@Component({
    selector: 'app-logo-wrapper',
    imports: [CommonModule, LogoPickerComponent],
    template: `
        <mca-logo-picker [appType]="initAppService.appType$ | async" [scale]="scale"></mca-logo-picker>
    `,
})
export class LogoWrapperComponent extends BaseLogoComponent {
    protected readonly initAppService = inject(InitAppService);
}
